module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_zan.4ed12.png";